module.exports = __webpack_public_path__ + "static/media/Robert Baylor Headshot_1591272458165.c8eb3183.jpeg";